import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import { useLazyForgotPasswordQuery } from '@greenkub-fronts/data-access';
import { usePostHog } from 'posthog-js/react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

type FormData = {
  email: string;
};

const schema = yup
  .object()
  .shape({
    email: yup.string().email().required('Un email est requis'),
  })
  .required();

export function useForgetPasswordFormFeature() {
  const [focusedField, setFocusedField] = useState<string | null>('');

  const [postForgotPassword, postForgotPasswordQuery] =
    useLazyForgotPasswordQuery();

  const [successMsg, setSuccessMsg] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('');

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    control,
  } = useForm<FormData>({
    resolver: yupResolver(schema),
  });

  const postHog = usePostHog();

  const onSubmit: SubmitHandler<FormData> = (data) => {
    if (postForgotPasswordQuery.isLoading) return;

    postForgotPassword({ email: data.email }).then((resp: any) => {
      if (resp.error) {
        setSuccessMsg('');
        setErrorMsg(resp.error.message);
        postHog?.capture('forget-password-error', {
          email: data.email,
        });
      } else {
        setSuccessMsg(resp.data.message);
        setErrorMsg('');
        postHog?.capture('forget-password', {
          email: data.email,
        });
      }
    });
  };

  return {
    register,
    handleSubmit,
    watch,
    errors,
    onSubmit,
    focusedField,
    setFocusedField,
    successMsg,
    errorMsg,
    isLoading: postForgotPasswordQuery.isLoading,
    control,
  };
}

export default useForgetPasswordFormFeature;
